import {Col, Row} from "antd";
import {
    ShiftReportStatusFilter,
    SubCompanyFilter
} from "components/_defaultComponents/FilterComponents";
import {DatePickerButtons} from "components/_defaultComponents/FilterComponents";
import FutureShiftsTable from "components/shiftScore/Components/FutureShiftsTable";
import {useStore} from "hooks/useStore";
import React, {useState} from "react";
import {
    FilterTab,
    FilterTabsContainer,
    FilterTabContent,
    FutureShiftsFilters,
    SubcompanyFilterContainer,
    RightFiltersContainer,
    LeftFiltersContainer
} from "../CustomerHomePageWithShiftScore.styles";
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    InboxOutlined,
    UnorderedListOutlined
} from "@ant-design/icons";

const FutureShifts = ({
    futureShiftsFilters,
    setFutureShiftsFilters,
    hasMultipleSubcompanies,
    reloadData,
    setReloadData,
    reloadCount,
    setReloadCount,
    onFutureSubCompanyChange,
    futureLoading,
    futureData,
    setFutureData,
    futureCurrentPage,
    setFutureCurrentPage
}) => {
    const stores = useStore();
    const [isFutureShifts, setIsFutureShifts] = useState(true);

    const handleFilterChange = (newFilters, period) => {
        setFutureShiftsFilters(newFilters);
        if (period !== "today") {
            setFutureShiftsFilters(prev => ({
                ...prev,
                status: "all"
            }));
        }
    };

    return (
        <>
            <FutureShiftsFilters hasMultipleSubcompanies={hasMultipleSubcompanies}>
                <LeftFiltersContainer>
                    {hasMultipleSubcompanies && (
                        <SubcompanyFilterContainer>
                            <SubCompanyFilter
                                defaultValue={futureShiftsFilters.subCompany}
                                value={futureShiftsFilters.subCompany}
                                onChange={onFutureSubCompanyChange}
                                company={stores?.meStore?.companies?.[0]?._id}
                                mode="multiple"
                                showAllOption={true}
                                allowClear={true}
                                disabled={false}
                                initialCall={true}
                            />
                        </SubcompanyFilterContainer>
                    )}
                    <DatePickerButtons
                        filters={futureShiftsFilters}
                        setFilters={setFutureShiftsFilters}
                        type="future"
                        onFilterChange={handleFilterChange}
                    />
                </LeftFiltersContainer>
            </FutureShiftsFilters>

            {/* Future Shifts Table */}
            <FutureShiftsTable
                loading={futureLoading}
                data={futureData?.rows || []}
                setData={setFutureData}
                dataCount={futureData?.dataCount}
                currentPage={futureCurrentPage}
                setCurrentPage={setFutureCurrentPage}
                setReloadData={() => setReloadData(!reloadData)}
                setReloadCount={() => setReloadCount(!reloadCount)}
                filters={futureShiftsFilters}
                isFutureShifts={isFutureShifts}
            />
        </>
    );
};

export default FutureShifts;
